import Icon from '../Controls/Icon/Icon';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { OrderPaymentType } from 'src/mobx/ordersHistoryStore/types';
import { formatImagePath } from 'src/utils/formatter';

const OrderPaymentTypeIcon = ({ paymentType, size = 24 }: { paymentType: OrderPaymentType; size?: number }) => {
  const orderPaymentTypeIconNameMap = {
    [OrderPaymentType.Terminal]: <Icon name={Icons.Terminal} size={size} />,
    [OrderPaymentType.Card]: <Icon name={Icons.Card} size={size} />,
    // [OrderPaymentType.Points]: <Icon name={Icons.Points} size={size} />,
    [OrderPaymentType.Cash]: <Icon name={Icons.Cash} size={size} />,
    [OrderPaymentType.Careem]: <img src={formatImagePath(`${Icons.IcCareem}.svg`)} alt="Careem" style={{ width: size, height: size }} />,
    [OrderPaymentType.Jahez]: <img src={formatImagePath(`${Icons.IcJahez}.svg`)} alt="Jahez" style={{ width: size, height: size }} />,
    [OrderPaymentType.DookOnline]: <img src={formatImagePath(`${Icons.IcDookOnline}.svg`)} alt="Dook Online" style={{ width: size, height: size }} />,
    [OrderPaymentType.DookCash]: <img src={formatImagePath(`${Icons.IcDookCash}.svg`)} alt="Dook Cash" style={{ width: size, height: size }} />,
    [OrderPaymentType.HungerStation]: (
      <img src={formatImagePath(`${Icons.IcHungerStation}.svg`)} alt="HungerStation" style={{ width: size, height: size }} />
    ),
    [OrderPaymentType.ToYou]: <img src={formatImagePath(`${Icons.IcToYou}.svg`)} alt="ToYou" style={{ width: size, height: size }} />,
    [OrderPaymentType.Keeta]: <img src={formatImagePath(`${Icons.IcKeeta}.svg`)} alt="Keeta" style={{ width: size, height: size }} />,
  };
  return orderPaymentTypeIconNameMap[paymentType];
};

export default OrderPaymentTypeIcon;
